// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"UploadFile_wrapper__3vmhj","noEditIconWrapper":"UploadFile_noEditIconWrapper__3S3UC","withEditIconWrapper":"UploadFile_withEditIconWrapper__2TW7w"};